import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent, SvgIcons } from '@ngneat/svg-icon';
import { PhoneFormatPipe } from '@libs/patients';

@Component({
  selector: 'lib-health-history-patient-details-item',
  imports: [CommonModule, SvgIconComponent, PhoneFormatPipe],
  templateUrl: './health-history-patient-details-item.component.html',
  styleUrl: './health-history-patient-details-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthHistoryPatientDetailsItemComponent {
  public displayText = input<string>('');
  public icon = input<SvgIcons>('px-24-phone');
}
